import { ParamsEnum } from './models/params.enum';

export const paramsConfig = {
  page: ParamsEnum.NUMBER,
  search: ParamsEnum.STRING,
  sort: ParamsEnum.STRING,
  isActive: ParamsEnum.BOOLEAN,
  userId: ParamsEnum.NUMBER,
} as const;
